import React from 'react';
import { StepBar, StepBarContainer, StepBarOuterContainer, StepIndicatorContainer, StepIndicatorText } from './StepIndicator-styled';
import { ILuxeMenuTab } from '../MenuLUXE';


interface Props {
  tabs:ILuxeMenuTab[],
  currentMenuTab:number,
  mobile:boolean,
  menuScaleFactor:number
}

interface State {
}

export default class StepIndicator extends React.Component<Props,State> {
  constructor(props) {
    super(props);
  };

	componentDidMount() {
	};

  render() {
    const { tabs, currentMenuTab, mobile, menuScaleFactor } = this.props;

    return (
      <StepIndicatorContainer mobile={mobile} menuScaleFactor={menuScaleFactor}>
        <StepBarOuterContainer>
          {tabs.map((tab, ind) => {
            return (
              <StepBarContainer
                isActive={currentMenuTab == ind}
                title={tab.title}
                key={ind}
              >
                <StepBar
                  isActive={currentMenuTab == ind}
                />
              </StepBarContainer>
            )
          })}
        </StepBarOuterContainer>
        <StepIndicatorText>
          Step {currentMenuTab+1} of {tabs.length}
        </StepIndicatorText>
      </StepIndicatorContainer>
    );
  }
};
